<div class="layout-topbar bg-primary text-white">
  <a class="layout-topbar-logo">
    <img src="assets/layout/images/logo-mincultura.png" alt="logo" style="height: 4.0rem;">
    <span class="text-base text-white">Ministerio de cultura</span>
  </a>
  <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()">
    <i class="pi pi-ellipsis-v"></i>
  </button>
  <div #topbarmenu class="layout-topbar-menu"
    [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
    <div class="flex justify-content-center align-items-center gap-2">
      <span class="font-semibold">{{ nameUser }}</span>
      <p-button severity="danger" icon="pi pi-sign-out" />
    </div>
  </div>
</div>